import React from "react";
import bigCardBgImage from "../../assets/img/bg.jpeg";

const WhatDrivesUs = () => {
	const sectionData = {
		title: "What Drives Us",
		bigCardBgImage: bigCardBgImage,
		cards: [
			{
				title: "Equity",
				description: "We champion healthcare as a fundamental right.",
			},
			{
				title: "Empathy",
				description: "We prioritize patient-centric solutions.",
			},
			{
				title: "Integrity",
				description: "We uphold transparency and trust in all we do.",
			},
			{
				title: "Community Impact",
				description:
					"We bridge gaps between patients, providers, and social services.",
			},
		],
	};

	return (
		<div className='max-w-[1440px] sm:w-[90%] w-full mx-auto py-16 space-y-3'>
			{/* Outer Section */}

			{/* Title */}
			<h2 className='text-4xl md:text-5xl font-bold md:mb-12 mb-6 text-[#1D1D1D] w-[90%] mx-auto sm:w-full'>
				{sectionData.title}
			</h2>

			{/* Big Card with Background */}
			<div
				className='relative bg-cover bg-no-repeat bg-center bg-fixed sm:rounded-[30px] '
				style={{
					backgroundImage: `url(${sectionData.bigCardBgImage})`,
				}}>
				<div className=' bg-black/50 sm:rounded-[30px] sm:pb-7 w-full lg:pt-[250px] sm:pt-[100px] py-5 '>
					{/* Small Cards Section */}
					<div className='sm:w-[90%] w-full mx-auto flex lg:flex-nowrap flex-wrap xl:gap-14 sm:gap-10 gap-3 sm:px-0 px-1 lg:justify-between justify-center h-full'>
						{sectionData.cards.map((card, index) => (
							<div
								key={index}
								className=' sm:max-w-[280px] max-w-[150px] w-full bg-[#FFEAC8] flex flex-col sm:justify-normal justify-between sm:gap-y-[43px] xl:p-6 sm:p-4 p-[9px] text-[#025788] sm:rounded-[20px] rounded-[8px] shadow-md'>
								<h3 className='sm:text-[32px]/10 text-2xl/8 font-semibold mb-4'>
									{card.title}
								</h3>
								<p className='sm:text-lg/7 text-base/6'>{card.description}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default WhatDrivesUs;
